// import React, { useState } from 'react';
// import { ServicePageHeader } from './ServicePageHeader';
// import { Building2, Landmark, ShieldCheck, Handshake } from 'lucide-react';

// export const Partners = () => {
//   const [activeCategory, setActiveCategory] = useState('all');

//   // تصنيفات الشركاء الاستراتيجيين
//   const categories = [
//     { id: 'all', name: 'جميع الشركاء', icon: <Handshake className="w-4 h-4" /> },
//     // { id: 'financial', name: 'المؤسسات المالية والبنوك', icon: <Landmark className="w-4 h-4" /> },
//     { id: 'corporate', name: 'القطاع التجاري والشركات', icon: <Building2 className="w-4 h-4" /> },
//     { id: 'alliances', name: 'التحالفات القانونية والدولية', icon: <ShieldCheck className="w-4 h-4" /> },
//   ];

//   // مصفوفة الشركاء المحدثة لتقرأ ملفات الصور الخاصة بك مباشرة
//   const partnersData = [
//     { 
//       name: 'شركة البيك للمأكولات السريعة', 
//       category: 'corporate', 
//       desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
//       logoPath: '/logos/albaik.png' // مسار الشعار داخل مجلد public/logos/
//     },
//     { 
//       name: 'شركة آجاد', 
//       category: 'corporate', 
//       desc: 'إدارة الامتثال والحوكمة وتأمين البنية التعاقدية للاستثمارات والأعمال التجارية.',
//       logoPath: '/logos/ajad.png'
//     },
//     { 
//       name: 'شركة بحر آسيا', 
//       category: 'corporate', 
//       desc: 'استشارات التجارة البحرية واللوجستية وصياغة اتفاقيات التوريد والشراكات الاستراتيجية.',
//       logoPath: '/logos/asia-sea.png'
//     },
//     { 
//       name: 'مجموعة بن لادن السعودية', 
//       category: 'alliances', 
//       desc: 'المشورة القانونية في عقود المقاولات الإنشائية الكبرى، الحوكمة، ومنازعات المشاريع.',
//       logoPath: '/logos/binladen.png'
//     },
//     { 
//       name: 'شركة ركاز العقارية', 
//       category: 'alliances', 
//       desc: 'تطوير الصناديق الاستثمارية العقارية، التسجيل العقاري، وإجراءات منازعات الملكية والتطوير.',
//       logoPath: '/logos/rekaz.png'
//     },
//     { 
//       name: 'شركة صفوة التشخيص الطبية', 
//       category: 'corporate', 
//       desc: 'صياغة اللوائح الداخلية للقطاع الصحي وضمان الامتثال للأنظمة والتشريعات الطبية.',
//       logoPath: '/logos/safwa.png'
//     },
//     { 
//       name: 'شركة قصة المكان', 
//       category: 'alliances', 
//       desc: 'استشارات التطوير العقاري والهندسي وصياغة عقود المقاولات والتصميم والتشغيل.',
//       logoPath: '/logos/place-story.png'
//     },
//     { 
//       name: 'منتجع أوشيا السياحي (OIA Beach Resort)', 
//       category: 'alliances', 
//       desc: 'الدعم الوقائي والقانوني لقطاع الضيافة والسياحة وصياغة عقود الاستثمار والتشغيل الفندقي.',
//       logoPath: '/logos/oia.png'
//     }
//   ];
//   // const partnersData = [
//   //   { 
//   //     name: 'شركة البيك للأنظمة الغذائية', 
//   //     category: 'corporate', 
//   //     logoText: 'ALBAIK', 
//   //     desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.' 
//   //   },
//   //   { 
//   //     name: 'شركة آجاد', 
//   //     category: 'corporate', 
//   //     logoText: 'AJAD', 
//   //     desc: 'إدارة الامتثال والحوكمة وتأمين البنية التعاقدية للاستثمارات والأعمال التجارية.' 
//   //   },
//   //   { 
//   //     name: 'شركة بحر آسيا', 
//   //     category: 'corporate', 
//   //     logoText: 'Asia Sea', 
//   //     desc: 'استشارات التجارة البحرية واللوجستية وصياغة اتفاقيات التوريد والشراكات الاستراتيجية.' 
//   //   },
//   //   { 
//   //     name: 'مجموعة بن لادن السعودية', 
//   //     category: 'alliances', 
//   //     logoText: 'SBG', 
//   //     desc: 'المشورة القانونية في عقود المقاولات الإنشائية الكبرى، الحوكمة، ومنازعات المشاريع.' 
//   //   },
//   //   { 
//   //     name: 'شركة ركاز العقارية', 
//   //     category: 'corporate', 
//   //     logoText: 'REKAZ', 
//   //     desc: 'تطوير الصناديق الاستثمارية العقارية، التسجيل العقاري، وإجراءات منازعات الملكية والتطوير.' 
//   //   },
//   //   { 
//   //     name: 'شركة صفوة التشخيص الطبية', 
//   //     category: 'corporate', 
//   //     logoText: 'SAFWA', 
//   //     desc: 'صياغة اللوائح الداخلية للقطاع الصحي وضمان الامتثال للأنظمة والتشريعات الطبية.' 
//   //   },
//   //   { 
//   //     name: 'شركة قصة المكان', 
//   //     category: 'corporate', 
//   //     logoText: 'Qessat AlMakan', 
//   //     desc: 'استشارات التطوير العقاري والهندسي وصياغة عقود المقاولات والتصميم والتشغيل.' 
//   //   },
//   //   { 
//   //     name: 'منتجع آويا السياحي (OIA Beach Resort)', 
//   //     category: 'alliances', 
//   //     logoText: 'OIA', 
//   //     desc: 'الدعم الوقائي والقانوني لقطاع الضيافة والسياحة وصياغة عقود الاستثمار والتشغيل الفندقي.' 
//   //   }
//   // ];

//   // تصفية الشركاء بناءً على التبويب النشط
//   const filteredPartners = activeCategory === 'all' 
//     ? partnersData 
//     : partnersData.filter(p => p.category === activeCategory);

//   return (
//     <div className="bg-slate-950 min-h-screen" dir="rtl">
//       {/* 1. استدعاء الهيدر الموحد للخدمات والصفحات الفرعية */}
//       {/* <ServicePageHeader 
//         title="شركاؤنا الاستراتيجيون" 
//         currentPath="/partners" 
//       /> */}

//       {/* 2. محتوى صفحة الشركاء */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
//         {/* نص تمهيدي فخم */}
//         <div className="max-w-3xl mb-12">
//           <h2 className="text-xl md:text-3xl font-bold text-white mb-4">
//             تحالفات وثيقة لحماية وتطوير أعمالكم
//           </h2>
//           <p className="text-slate-400 font-light leading-relaxed text-sm md:text-base">
//             نفخر في شركة ناصر الراجحي ورامي المطيري ببناء شراكات مستدامة مع أقطاب القطاع المالي والتجاري والهيئات المنظمة، لتوفير بيئة قانونية متكاملة تدعم نمو واستقرار عملائنا محلياً ودولياً.
//           </p>
//         </div>

//         {/* أزرار الفلترة والتصنيف */}
//         <div className="flex flex-wrap gap-2 mb-10 bg-slate-900/40 p-2 rounded-2xl border border-slate-900 overflow-x-auto whitespace-nowrap">
//           {categories.map((cat) => (
//             <button
//               key={cat.id}
//               onClick={() => setActiveCategory(cat.id)}
//               className={`flex items-center gap-2 py-2.5 px-5 rounded-xl text-xs md:text-sm font-bold transition-all ${
//                 activeCategory === cat.id
//                   ? 'bg-amber-500 text-slate-950 shadow-lg shadow-amber-500/10'
//                   : 'text-slate-400 hover:text-white hover:bg-slate-900'
//               }`}
//             >
//               {cat.icon}
//               <span>{cat.name}</span>
//             </button>
//           ))}
//         </div>

//         {/* شبكة عرض الشركاء (Cards Network) */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {filteredPartners.map((partner, index) => (
//             <div 
//               key={index} 
//               className="bg-slate-900/40 border border-slate-900 rounded-2xl p-6 flex flex-col justify-between hover:border-amber-500/30 transition-all duration-300 group hover:-translate-y-1 shadow-xl relative overflow-hidden"
//             >
//               {/* تأثير التوهج الخلفي الخفيف لكل بطاقة */}
//               <div className="absolute top-0 left-0 w-24 h-24 bg-amber-500/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

//               <div>
//                 {/* مساحة الشعار (حيث يتم وضع لوقو الشركة) */}
//                 <div className="w-full h-20 bg-slate-950 rounded-xl border border-slate-800 flex items-center justify-center mb-5 group-hover:border-slate-700 transition-colors">
//                   {/* هنا يوضع وسم الـ <img> الفعلي، حالياً نص رصين بتأثير الفلتر */}
//                   <span className="text-lg font-extrabold tracking-wider text-slate-500 group-hover:text-amber-400 transition-colors duration-300">
//                     {partner.logoText}
//                   </span>
//                 </div>

//                 {/* اسم الشريك وطبيعة التعاون */}
//                 <h3 className="text-white font-bold text-base mb-2 group-hover:text-amber-400 transition-colors">
//                   {partner.name}
//                 </h3>
//                 <p className="text-slate-400 text-xs md:text-sm font-light leading-relaxed">
//                   {partner.desc}
//                 </p>
//               </div>

//               {/* خط ذهبي ديكوري سفلي يظهر عند التحويم */}
//               <div className="w-0 h-0.5 bg-amber-500 absolute bottom-0 right-0 group-hover:w-full transition-all duration-300"></div>
//             </div>
//           ))}
//         </div>

//         {/* صندوق إغلاق يدعو المنشآت لطلب عقد شراكة استراتيجية مع المكتب */}
//         <div className="mt-20 bg-gradient-to-r from-slate-900 to-slate-950 border border-slate-800 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl"></div>
//           <div className="relative z-10 text-center md:text-right">
//             <h3 className="text-white font-bold text-xl md:text-2xl mb-2">هل ترغب منشأتكم في الانضمام لشبكتنا الاستراتيجية؟</h3>
//             <p className="text-slate-400 text-sm font-light">نرحب دائماً بالتعاون وبناء الشراكات مع الكيانات الرائدة لتقديم الدعم الحوكمي والوقائي.</p>
//           </div>
//           <a 
//             href="#contact" 
//             className="relative z-10 bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold px-6 py-3 rounded-xl transition-all duration-300 text-sm md:text-base whitespace-nowrap shadow-lg shadow-amber-500/5 transform hover:-translate-y-0.5"
//           >
//             طلب شراكة استراتيجية
//           </a>
//         </div>

//       </div>
//     </div>
//   );
// };


// import React, { useState } from 'react';
// import { ServicePageHeader } from './ServicePageHeader';
// import { Building2, Landmark, ShieldCheck, Handshake } from 'lucide-react';

// export const Partners = () => {
//   const [activeCategory, setActiveCategory] = useState('all');

//   // تصنيفات الشركاء الاستراتيجيين
//   const categories = [
//     { id: 'all', name: 'جميع الشركاء', icon: <Handshake className="w-4 h-4" /> },
//     { id: 'corporate', name: 'القطاع التجاري والشركات', icon: <Building2 className="w-4 h-4" /> },
//     { id: 'alliances', name: 'التحالفات القانونية والدولية', icon: <ShieldCheck className="w-4 h-4" /> },
//   ];

//   // مصفوفة الشركاء النشطة بقراءة ملفات الصور مباشرة
//   const partnersData = [
//     { 
//       name: 'شركة البيك للمأكولات السريعة', 
//       category: 'corporate', 
//       logoPath:"https://ik.imagekit.io/j78bbzr9d/albaik.png",
//       desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',

//     },
//     { 
//       name: 'شركة آجاد', 
//       category: 'corporate', 
//       desc: 'إدارة الامتثال والحوكمة وتأمين البنية التعاقدية للاستثمارات والأعمال التجارية.',
// logoPath:"https://ik.imagekit.io/j78bbzr9d/ajad.png"
//     },
//     { 
//       name: 'شركة بحر آسيا', 
//       category: 'corporate', 
//       desc: 'استشارات التجارة البحرية واللوجستية وصياغة اتفاقيات التوريد والشراكات الاستراتيجية.',
//       logoPath:"https://ik.imagekit.io/j78bbzr9d/asia-sea.png"
//     },
//     { 
//       name: 'مجموعة بن لادن السعودية', 
//       category: 'alliances', 
//       desc: 'المشورة القانونية في عقود المقاولات الإنشائية الكبرى، الحوكمة، ومنازعات المشاريع.',
// logoPath:"https://ik.imagekit.io/j78bbzr9d/binladen.png"
//     },
//     { 
//       name: 'شركة ركاز العقارية', 
//       category: 'alliances', 
//       logoPath:"https://ik.imagekit.io/j78bbzr9d/rekaz.png",
//       desc: 'تطوير الصناديق الاستثمارية العقارية، التسجيل العقاري، وإجراءات منازعات الملكية والتطوير.',
//     },
//     { 
//       name: 'شركة صفوة التشخيص الطبية', 
//       category: 'corporate', 
//       desc: 'صياغة اللوائح الداخلية للقطاع الصحي وضمان الامتثال للأنظمة والتشريعات الطبية.',
// logoPath:"https://ik.imagekit.io/j78bbzr9d/safwa.png"
//     },
//     { 
//       name: 'شركة قصة المكان', 
//       category: 'alliances', 
//       logoPath:"https://ik.imagekit.io/j78bbzr9d/qisa.png",
//       desc: 'استشارات التطوير العقاري والهندسي وصياغة عقود المقاولات والتصميم والتشغيل.',
//     },
//     { 
//       name: 'منتجع آويا السياحي (OIA Beach Resort)', 
//       category: 'alliances', 
//       logoPath:"https://ik.imagekit.io/j78bbzr9d/oia.png",
//       desc: 'الدعم الوقائي والقانوني لقطاع الضيافة والسياحة وصياغة عقود الاستثمار والتشغيل الفندقي.',
//     }
//   ];

//   // تصفية الشركاء بناءً على التبويب النشط
//   const filteredPartners = activeCategory === 'all' 
//     ? partnersData 
//     : partnersData.filter(p => p.category === activeCategory);

//   return (
//     <div id="partners" className="bg-slate-950 min-h-screen" dir="rtl">
//       {/* 1. الهيدر الموحد لصفحة الشركاء */}
//       {/* <ServicePageHeader 
//         title="شركاؤنا الاستراتيجيون" 
//         currentPath="/partners" 
//       /> */}

//       {/* 2. محتوى صفحة الشركاء */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
//         {/* نص تمهيدي فخم */}
//         <div className="max-w-3xl mb-12">
//           <h2 className="text-xl md:text-3xl font-bold text-white mb-4">
//             تحالفات وثيقة لحماية وتطوير أعمالكم
//           </h2>
//           <p className="text-slate-400 font-light leading-relaxed text-sm md:text-base">
//             نفخر في شركة ناصر الراجحي ورامي المطيري ببناء شراكات مستدامة مع أقطاب القطاع المالي والتجاري والهيئات المنظمة، لتوفير بيئة قانونية متكاملة تدعم نمو واستقرار عملائنا محلياً ودولياً.
//           </p>
//         </div>

//         {/* أزرار الفلترة والتصنيف */}
//         <div className="flex flex-wrap gap-2 mb-10 bg-slate-900/40 p-2 rounded-2xl border border-slate-900 overflow-x-auto whitespace-nowrap">
//           {categories.map((cat) => (
//             <button
//               key={cat.id}
//               onClick={() => setActiveCategory(cat.id)}
//               className={`flex items-center gap-2 py-2.5 px-5 rounded-xl text-xs md:text-sm font-bold transition-all ${
//                 activeCategory === cat.id
//                   ? 'bg-amber-500 text-slate-950 shadow-lg shadow-amber-500/10'
//                   : 'text-slate-400 hover:text-white hover:bg-slate-900'
//               }`}
//             >
//               {cat.icon}
//               <span>{cat.name}</span>
//             </button>
//           ))}
//         </div>

//         {/* شبكة عرض الشركاء (Cards Network) */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {filteredPartners.map((partner, index) => (
//             <div 
//               key={index} 
//               className="bg-slate-900/40 border border-slate-900 rounded-2xl p-6 flex flex-col justify-between hover:border-amber-500/30 transition-all duration-300 group hover:-translate-y-1 shadow-xl relative overflow-hidden"
//             >
//               {/* تأثير التوهج الخلفي الخفيف لكل بطاقة */}
//               <div className="absolute top-0 left-0 w-24 h-24 bg-amber-500/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

//               <div>
//                 {/* مساحة الشعار (تم التحديث ليعرض الصور الحقيقية بدلاً من النصوص القديمة) */}
//                 <div className="w-full h-28 bg-slate-950 rounded-xl border border-slate-800 flex items-center justify-center mb-5 group-hover:border-slate-700 transition-colors p-4">
//                   <img 
//                     src={partner.logoPath} 
//                     alt={partner.name}
//                     className="max-h-16 max-w-full object-contain filter grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
//                   />
//                 </div>

//                 {/* اسم الشريك وطبيعة التعاون */}
//                 <h3 className="text-white font-bold text-base mb-2 group-hover:text-amber-400 transition-colors">
//                   {partner.name}
//                 </h3>
//                 <p className="text-slate-400 text-xs md:text-sm font-light leading-relaxed">
//                   {partner.desc}
//                 </p>
//               </div>

//               {/* خط ذهبي ديكوري سفلي يظهر عند التحويم */}
//               <div className="w-0 h-0.5 bg-amber-500 absolute bottom-0 right-0 group-hover:w-full transition-all duration-300"></div>
//             </div>
//           ))}
//         </div>

//         {/* صندوق إغلاق يدعو المنشآت لطلب عقد شراكة استراتيجية مع المكتب */}
//         <div className="mt-20 bg-gradient-to-r from-slate-900 to-slate-950 border border-slate-800 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl"></div>
//           <div className="relative z-10 text-center md:text-right">
//             <h3 className="text-white font-bold text-xl md:text-2xl mb-2">هل ترغب منشأتكم في الانضمام لشبكتنا الاستراتيجية؟</h3>
//             <p className="text-slate-400 text-sm font-light">نرحب دائماً بالتعاون وبناء الشراكات مع الكيانات الرائدة لتقديم الدعم الحوكمي والوقائي.</p>
//           </div>
//           <a 
//             href="#contact" 
//             className="relative z-10 bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold px-6 py-3 rounded-xl transition-all duration-300 text-sm md:text-base whitespace-nowrap shadow-lg shadow-amber-500/5 transform hover:-translate-y-0.5"
//           >
//             طلب شراكة استراتيجية
//           </a>
//         </div>

//       </div>
//     </div>
//   );
// };

import React, { useState } from 'react';
import { Building2, Landmark, ShieldCheck, Handshake } from 'lucide-react';
import LogoOfSaudia from './assets/cmp/Logo_of_Saudia.webp';
import binladen from './assets/cmp/binladen.webp';
import albaik from './assets/cmp/albaik.png';
import sal from './assets/cmp/sall.webp';
import safwa from './assets/cmp/safwa.webp';
import qisa from './assets/cmp/qisa.webp';
export const Partners = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  // تصنيفات الشركاء الاستراتيجيين
  const categories = [
    { id: 'all', name: 'عملاء نفخر بتقديم خدماتنا لهم', icon: <Handshake className="w-4 h-4" /> },
    // { id: 'all', name: 'جميع الشركاء', icon: <Handshake className="w-4 h-4" /> },
    // { id: 'corporate', name: 'القطاع التجاري والشركات', icon: <Building2 className="w-4 h-4" /> },
    // { id: 'alliances', name: 'التحالفات القانونية والدولية', icon: <ShieldCheck className="w-4 h-4" /> },
  ];

  // مصفوفة الشركاء النشطة بقراءة ملفات الصور مباشرة
  const partnersData = [
    { 
      name: '    جمعية خيركم ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9%20%D8%AE%D9%8A%D8%B1%D9%83%D9%85.webp?updatedAt=1788960790924",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: '    جمعية خيركم ', 
      category: 'corporate', 
      logoPath:"https://ik.imagekit.io/j78bbzr9d/%D8%A7%D9%84%D9%88%D9%85%D8%A7%D9%83%D9%88.webp?updatedAt=1788960790982",
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    // { 
    //   name: '  العمودي للسجاد و الموكيت ', 
    //   category: 'corporate', 
    //   desc: 'إدارة الامتثال والحوكمة وتأمين البنية التعاقدية للاستثمارات والأعمال التجارية.',
    //   logoPath:"https://ik.imagekit.io/j78bbzr9d/%D8%A7%D9%84%D8%B9%D9%85%D9%88%D8%AF%D9%8A%20%D9%84%D9%84%D8%B3%D8%AC%D8%A7%D8%AF.webp?updatedAt=1788960790863"
    // },
    { 
      name: '    cma', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%B3%D9%8A%20%D8%A7%D9%85%20%D8%A7%D9%8A%D9%87.webp?updatedAt=1788960791456",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: '    اسماك ثراء ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%A7%D8%B3%D9%85%D8%A7%D8%B7%20%D8%AB%D8%B1%D8%A7%D8%A1.webp?updatedAt=1788960791115",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: 'الانماء طوكيو مارين    ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%A7%D9%84%D8%A7%D9%86%D9%85%D8%A7%D8%A1%20%D8%B7%D9%88%D9%83%D9%8A%D9%88%20%D9%85%D8%A7%D8%B1%D9%8A%D9%86.webp?updatedAt=1788960791153",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: '    جمعية كافل ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9%20%D9%83%D8%A7%D9%81%D9%84.webp?updatedAt=1788960791282",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: '    شركة دخون ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%AF%D8%AE%D9%88%D9%86.webp?updatedAt=1788960791107",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: 'نادي سباقات الخيل     ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D9%86%D8%A7%D8%AF%D9%8A%20%D8%A7%D9%84%D8%AE%D9%8A%D9%84.webp?updatedAt=1788960791343",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    // { 
    //   name: '    المصباح', 
    //   category: 'corporate', 
    //   // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
    //   logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%A7%D9%84%D9%85%D8%B5%D8%A8%D8%A7%D8%AD%201.webp?updatedAt=1788960790906",
    //   desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    // },
    { 
      name: 'شركة   الخطوط السعودية', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: LogoOfSaudia,
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: '    مصنع الفاخرات ', 
      category: 'corporate', 
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
      logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%A7%D9%84%D9%81%D8%A7%D8%AE%D8%B1%D8%A7%D8%AA.jpg?updatedAt=1788961786768",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    // { 
    //   name: 'دثار    ', 
    //   category: 'corporate', 
    //   // logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/Logo_of_Saudia.webp?updatedAt=1780386672505",
    //   logoPath: "https://ik.imagekit.io/j78bbzr9d/%D8%AF%D8%AB%D8%A7%D8%B1%20%D8%A7%D9%84%D9%88%D8%B7%D9%86%D9%8A.webp?updatedAt=1788960791244",
    //   desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    // },
    { 
      name: 'شركة البيك للمأكولات السريعة', 
      category: 'corporate', 
      logoPath:albaik,
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/albaik.png",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: 'شركة   سال', 
      category: 'corporate', 
      logoPath:sal,
      
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/sall.webp?updatedAt=1780385953168",
      desc: 'الدعم القانوني المتكامل للعلامة التجارية وعقود الامتياز التجاري والتوسع التشغيلي.',
    },
    { 
      name: 'منتجع آويا السياحي (OIA Beach Resort)', 
      category: 'alliances', 
      logoPath:"https://ik.imagekit.io/j78bbzr9d/oia.png",
      // logoPath:"https://ik.imagekit.io/j78bbzr9d/oia.png",
      desc: 'الدعم الوقائي والقانوني لقطاع الضيافة والسياحة وصياغة عقود الاستثمار والتشغيل الفندقي.',
    },
    { 
      name: 'مجموعة بن لادن السعودية', 
      category: 'alliances', 
      desc: 'المشورة القانونية في عقود المقاولات الإنشائية الكبرى، الحوكمة، ومنازعات المشاريع.',
      // logoPath:binladen,
      logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/binladen.webp?updatedAt=1780386672222"
    },
    // { 
    //   name: '  العمودي للسجاد و الموكيت ', 
    //   category: 'corporate', 
    //   desc: 'إدارة الامتثال والحوكمة وتأمين البنية التعاقدية للاستثمارات والأعمال التجارية.',
    //   logoPath:"https://ik.imagekit.io/j78bbzr9d/%D8%A7%D9%84%D8%B9%D9%85%D9%88%D8%AF%D9%8A%20%D9%84%D9%84%D8%B3%D8%AC%D8%A7%D8%AF.webp?updatedAt=1788960790863"
    // },
    // { 
    //   name: 'شركة بحر آسيا', 
    //   category: 'corporate', 
    //   desc: 'استشارات التجارة البحرية واللوجستية وصياغة اتفاقيات التوريد والشراكات الاستراتيجية.',
    //   // logoPath:"https://ik.imagekit.io/j78bbzr9d/asia-sea.png"
    //   logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/asia-sea_png.webp?updatedAt=1780386672587"
    // },
    // { 
    //   name: 'شركة ركاز العقارية', 
    //   category: 'alliances', 
    //   logoPath:"https://ik.imagekit.io/j78bbzr9d/rekaz.png",
    //   desc: 'تطوير الصناديق الاستثمارية العقارية، التسجيل العقاري، وإجراءات منازعات الملكية والتطوير.',
    // },
    { 
      name: 'شركة صفوة التشخيص الطبية', 
      category: 'corporate', 
      desc: 'صياغة اللوائح الداخلية للقطاع الصحي وضمان الامتثال للأنظمة والتشريعات الطبية.',
      // logoPath:safwa,
      logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/safwa.webp?updatedAt=1780386671933"
    },
    { 
      name: 'شركة قصة المكان', 
      category: 'alliances', 
      // logoPath:qisa,
      logoPath:"https://ik.imagekit.io/j78bbzr9d/webp_converted/qisa.webp?updatedAt=1780386671265",      desc: 'استشارات التطوير العقاري والهندسي وصياغة عقود المقاولات والتصميم والتشغيل.',
    }
  ];

  // تصفية الشركاء بناءً على التبويب النشط
  const filteredPartners = activeCategory === 'all' 
    ? partnersData 
    : partnersData.filter(p => p.category === activeCategory);

  return (
    // تحويل الخلفية إلى اللون الأبيض النظيف للنمط الفاتح الفخم
    <div id="partners" className="bg-white min-h-screen" dir="rtl">
      
      {/* محتوى صفحة الشركاء */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        
        {/* نص تمهيدي فخم */}
        <div className="max-w-3xl mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-4">
            تحالفات وثيقة لحماية وتطوير <span className="text-indigo-950">أعمالكم</span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-indigo-950 to-blue-500 mb-6 rounded-full"></div>
          <p className="text-black font-light leading-relaxed text-sm md:text-base">
            نعتز في شركة ناصر الراجحي ورامي المطيري ببناء شراكات مستدامة مع أقطاب القطاع المالي والتجاري والهيئات المنظمة، لتوفير بيئة قانونية متكاملة تدعم نمو واستقرار عملائنا محلياً ودولياً.
          </p>
        </div>

        {/* أزرار الفلترة والتصنيف المحدثة بخلفيات فاتحة ونظيفة */}
       
        <div className="justify-center flex flex-wrap gap-2 mb-10  p-2 rounded-2xl overflow-x-auto whitespace-nowrap">
        {/* <div className="justify-center flex flex-wrap gap-2 mb-10 bg-slate-50 p-2 rounded-2xl border border-slate-200 overflow-x-auto whitespace-nowrap"> */}
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`flex items-center gap-2 py-2.5 px-5 rounded-xl text-xs md:text-sm font-bold transition-all ${
                activeCategory === cat.id
                  ? 'bg-indigo-950 text-white shadow-lg shadow-indigo-950/10'
                  : 'text-slate-500 hover:text-indigo-950 hover:bg-slate-100'
              }`}
            >
              {cat.icon}
              <span>{cat.name}</span>
            </button>
          ))}
        </div>

        {/* شبكة عرض الشركاء بخلفيات بيضاء ناصعة وظلال ناعمة */}
        <div className="  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredPartners.map((partner, index) => (
            <div 
              key={index} 
              className=" bg-slate-200  border border-slate-100 rounded-2xl p-6 flex flex-col justify-between hover:border-indigo-950/10 transition-all duration-300 group hover:-translate-y-1 shadow-md hover:shadow-xl relative overflow-hidden"
            >
              {/* تأثير التوهج الخلفي الكحلي الخفيف جداً عند التحويم */}
              <div className="absolute top-0 left-0 w-24 h-24 bg-indigo-950/5 rounded-full blur-2xl opacity-0 transition-opacity duration-300"></div>
              {/* <div className="absolute top-0 left-0 w-24 h-24 bg-indigo-950/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div> */}
  {/* EFE3CA */}
{/* F1E2D1 */}
{/* EADBC8 */}
              <div
              className=''
              >
                {/* مساحة الشعار المحدثة للوضع الفاتح بخلفية رمادية خفيفة ونظيفة */}
                <div className="w-full h-28  rounded-xl  border-slate-100 flex items-center justify-center mb-5 group-hover:border-slate-200 transition-colors p-4">
                {/* <div className="w-full h-28 bg-slate-50 rounded-xl border border-slate-100 flex items-center justify-center mb-5 group-hover:border-slate-200 transition-colors p-4"> */}
                  <img 
                    src={partner.logoPath} 
                    alt={partner.name}
                    className="max-h-26 max-w-26 object-contain "
                    // className="max-h-16 max-w-full object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                  />
                </div>

                {/* اسم الشريك وطبيعة التعاون بالنصوص الداكنة الواضحة */}
                {/* <h3 className="text-slate-900 font-bold text-base mb-2 group-hover:text-indigo-950 transition-colors">
                  {partner.name}
                </h3> */}
                {/* <p className="text-slate-500 text-xs md:text-sm font-light leading-relaxed">
                  {partner.desc}
                </p> */}
              </div>

              {/* خط كحلي ديكوري سفلي يظهر عند التحويم */}
              <div className="w-0 h-0.5 bg-indigo-950 absolute bottom-0 right-0 group-hover:w-full transition-all duration-300"></div>
            </div>
          ))}
        </div>

        {/* صندوق إغلاق يدعو المنشآت لطلب عقد شراكة استراتيجية مع المكتب مصمم بنمط Navy الفخم */}
        <div className="mt-20 bg-gradient-to-r from-indigo-950 to-slate-900 border border-indigo-950/10 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden shadow-lg">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
          <div className="relative z-10 text-center md:text-right">
            <h3 className="text-white font-bold text-xl md:text-2xl mb-2">هل ترغب منشأتكم في الانضمام لشبكتنا الاستراتيجية؟</h3>
            <p className="text-slate-200 text-sm font-light">نرحب دائماً بالتعاون وبناء الشراكات مع الكيانات الرائدة لتقديم الدعم الحوكمي والوقائي.</p>
          </div>
          <a 
            href="#contact" 
            className="relative z-10 bg-white hover:bg-slate-100 text-indigo-950 font-bold px-6 py-3 rounded-xl transition-all duration-300 text-sm md:text-base whitespace-nowrap shadow-md transform hover:-translate-y-0.5"
          >
            طلب شراكة استراتيجية
          </a>
        </div>

      </div>
    </div>
  );
};